<svg
  width="42"
  height="80"
  viewBox="0 0 42 80"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    opacity="0.04"
    d="M24.2002 0H16.0504L0.0566785 79.7049L0 80H8.14987L24.1436 0.295172L24.2002 0ZM33.5403 0L17.5466 79.7049L17.4899 80H25.6398L41.6335 0.295172L41.6901 0H33.5403Z"
    fill="#121835"
  />
</svg>
